import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioBookByDetailPageApi = createApi({
  reducerPath: 'audioBookByDetailPageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioBookByDetailPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAudiobookByDetailData: builder.query({
      query: (option) => ({
        url : 'transaction_detail_free',
        method: 'POST',
        body : {
            "item_id": option,
            "phone": "",
            "platform": "miniapp",
            "udid": "190740e5f0032702",
            "user_id": getLocalStorageData(),
            "version_code": 29,
            "version_name": "1.2.9"
        },
      }), 
    })
  }),
});

export const { useFetchAudiobookByDetailDataQuery, endpoints } = audioBookByDetailPageApi;